// src/core/config/api.ts

import { ENV } from "./env";


export const AUTH_CONFIG = {

    APP_URL: ENV.AUTH_APP_URL,

    LOGIN_PATH: "/auth/login",

    AUTH_APP_URL: ENV.AUTH_APP_URL,

    CALLBACK_PATH: ENV.MYACCOUNT_CALLBACK_PATH,

} as const;



export const API = {

    BASE_URL: ENV.API_BASE_URL,

    STORAGE_BASE_URL: ENV.STORAGE_BASE_URL,


    AUTH: {

        STATUS: ENV.API_STATUS,

        REGISTER: ENV.API_REGISTER,

        LOGIN: ENV.API_LOGIN,

        REFRESH: ENV.API_REFRESH,

        ME: ENV.API_ME,

        LOGOUT: ENV.API_LOGOUT,


        FORGOT_PASSWORD: ENV.API_FORGOT_PASSWORD,

        VERIFY_RESET_CODE: ENV.API_VERIFY_RESET_CODE,

        RESET_PASSWORD: ENV.API_RESET_PASSWORD,

    },


    ACCOUNT: {

        PROFILE: ENV.API_PROFILE,

        EMAILS: ENV.API_EMAILS,

        PHONES: ENV.API_PHONES,

        AVATAR: ENV.API_AVATAR,


        PREFERENCES: ENV.API_PREFERENCES,


        CHANGE_PASSWORD_INIT:
            ENV.API_CHANGE_PASSWORD_INIT,


        CHANGE_PASSWORD_CONFIRM:
            ENV.API_CHANGE_PASSWORD_CONFIRM,


        SESSIONS: ENV.API_SESSIONS,

        DEVICES: ENV.API_DEVICES,

    },


    IAM: {

        ACCESS: ENV.API_IAM_ACCESS,

        CAN: ENV.API_IAM_CAN,

    },


} as const;